import React, { useState } from 'react';
import { X, Twitter, Linkedin } from 'lucide-react';

export default function AuthorBio() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="absolute top-8 left-8 z-20 text-white font-medium hover:text-blue-200 transition-colors duration-300"
      >
        <span className="text-lg">Mitali Bharali</span>
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl max-w-2xl w-full p-8 relative shadow-2xl">
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
            
            <div className="flex flex-col md:flex-row gap-8">
              {/* Author Image */}
              <div className="w-full md:w-1/3">
                <div className="aspect-square rounded-xl overflow-hidden bg-gradient-to-br from-blue-100 to-blue-200 shadow-lg">
                  <img
                    src="https://drive.google.com/thumbnail?id=1u-lqgF81SBCP24KjvVXkO23SsUDhhC-w&sz=w800"
                    alt="Mitali Bharali"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Author Bio */}
              <div className="w-full md:w-2/3">
                <h2 className="text-3xl font-serif font-bold text-blue-900 mb-2">Mitali Bharali</h2>
               
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Hi, I’m Mitali—a finance professional with a passion for decoding Capital Markets. 
                </p>
                <p className="text-gray-600 mb-8 leading-relaxed">
                  I created this space to share regular market color, offering clear, actionable insights drawn from real-time trends, macro shifts, and behavioral patterns. Whether you're a seasoned investor or just market-curious, my goal is to make the noise make sense. Off Market hours and off season, I find myself in shaping my other blog—Deuce & Double Fault—where I reflect on the sport, mental resiliance and the many parallels between the two. I’d love to hear your thoughts—feel free to reach out using the contact details below as I continue to refine my lens, both on markets and beyond.
                </p>
                <div className="flex gap-6">
                  <a
                    href="https://x.com/mitalibharali"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-blue-900 hover:text-blue-700 transition-colors"
                  >
                    <Twitter className="w-5 h-5" />
                    <span>Twitter</span>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/mitalibharali/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-blue-900 hover:text-blue-700 transition-colors"
                  >
                    <Linkedin className="w-5 h-5" />
                    <span>LinkedIn</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
} 
